import styled from "styled-components";

import { HubspotAdCard, ShoeAdCard } from "./AdMockupCards";
import { LogoShowcase } from "./LogoShowcase";

const IllustrationBox = styled.div`
    position: relative;
    width: 800px;
    height: 640px;
    flex-shrink: 0;
`;

const LogoRow = styled.div`
    position: absolute;
    top: 61px;
    left: 50%;
    transform: translateX(-50%);
`;

const ShoeCardSlot = styled.div`
    position: absolute;
    top: 212px;
    left: calc(50% + 182px);
    transform: translateX(-50%);
`;

const HubspotCardSlot = styled.div`
    position: absolute;
    top: 234px;
    left: calc(50% - 151px);
    transform: translateX(-50%);
`;

export const AiPromoIllustration = () => (
    <IllustrationBox data-automation="ai-channels-illustration">
        <ShoeCardSlot>
            <ShoeAdCard />
        </ShoeCardSlot>
        <HubspotCardSlot>
            <HubspotAdCard />
        </HubspotCardSlot>
        <LogoRow>
            <LogoShowcase />
        </LogoRow>
    </IllustrationBox>
);
